import Sidebar from "./Sidebar.jsx";
import Header from "./Header.jsx";
import { nav } from "../../config/navigation.js";
import { state } from "../../state/workspaceStore.js";
import { sidebarIcon } from "../icons/SidebarIcon.jsx";
import { nodes, attributes } from "../common/reactHelpers.jsx";
import { notices } from "../../utils/domain/model.js";
import { esc } from "../../utils/format.js";
import { avatar } from "./ProfileAvatar.jsx";
import { breadcrumbs } from "../navigation/Breadcrumbs.jsx";
export function layout(body) {
  const section =
    nav.find((n) => n[0] === state.current.route)?.[2] ||
    {
      product: "Products",
      "product-edit": "Products",
      collection: "Collections",
      "collection-edit": "Collections",
      order: "Orders",
      "order-new": "Orders",
      payment: "Payments",
      customer: "Customers",
      "customer-edit": "Customers",
      "coupon-edit": "Coupons",
      profile: "Profile",
      notifications: "Notifications",
    }[state.current.route] ||
    "Workspace";
  return (
    <div className={"layout " + (state.db.sidebarCollapsed ? "collapsed" : "")}>
      <Sidebar section={section} />
      <div className={"workspace"}>
        <Header />
        <main>
          {state.storageError ? (
            <div className={"notice amber"} role={"alert"}>
              {esc(state.storageError)}
            </div>
          ) : (
            ""
          )}
          {breadcrumbs()}
          {body}
        </main>
      </div>
    </div>
  );
}
export default function AppLayout({ children }) {
  return layout(children);
}
